import _ from "lodash";
import { SelectedSkuFilters } from "models/inventory/helpers/skuFilters.helpers";
import { types } from "../types/types";

export interface SkusReducerState {
  selectedFilters?: SelectedSkuFilters;
}

const INITIAL_STATE: SkusReducerState = {};

export const skusReducer = (
  // eslint-disable-next-line default-param-last
  state: SkusReducerState = INITIAL_STATE,
  action: { type: Partial<typeof types>; payload: any }
) => {
  switch (action.type) {
    case types.skusUpdateSelectedFilter:
      return {
        ...state,
        selectedFilters: _.omitBy({
          ...state.selectedFilters,
          [action.payload.key]: action.payload.value
        }, _.isUndefined)
      };
    case types.skusSetSelectedFilter:
      return {
        ...state,
        selectedFilters: action.payload.filters
      };
    case types.skusClearSelectedFilter:
      return { ...state, selectedFilters: undefined };
    default:
      return state;
  }
};
